
export default function Hero() {
  return (
    <section className="relative bg-white pt-40 pb-20 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="w-full">
            <h1 className="text-3xl md:text-4xl lg:text-[2.75rem] font-bold text-[#1B3A6B] mb-3 leading-tight">
              Florida's Home Experts
            </h1>
            <p className="text-base md:text-lg text-[#B22234] font-semibold mb-6">
              Powering Comfort. Protecting Homes.
            </p>
            <p className="text-lg md:text-xl text-gray-600 mb-8 max-w-xl leading-relaxed">
              Expert Plumbing, Heating, Air Conditioning &amp; Electrical Services Available 24/7 Across Florida
            </p>

            <div className="flex flex-col sm:flex-row items-start gap-4 mb-12">
              <a
                href="#contact"
                className="bg-[#B22234] text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-[#8B1A29] transition-all shadow-lg hover:shadow-[#B22234]/30 hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                Schedule Service Now
              </a>
              <a
                href="tel:+18005551234"
                className="bg-[#1B3A6B]/10 text-[#1B3A6B] px-8 py-4 rounded-lg text-lg font-semibold hover:bg-[#1B3A6B]/20 transition-all shadow-lg hover:scale-105 flex items-center space-x-2 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-fill text-[#B22234]"></i>
                <span>(800) 555-1234</span>
              </a>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              <div className="bg-[#1B3A6B]/5 rounded-lg p-4 text-center border border-[#1B3A6B]/10">
                <div className="w-10 h-10 bg-[#1B3A6B] rounded-full flex items-center justify-center mx-auto mb-2">
                  <i className="ri-customer-service-2-fill text-lg text-white"></i>
                </div>
                <p className="text-[#1B3A6B] font-semibold text-xs">24/7 Emergency</p>
              </div>

              <div className="bg-[#1B3A6B]/5 rounded-lg p-4 text-center border border-[#1B3A6B]/10">
                <div className="w-10 h-10 bg-[#B22234] rounded-full flex items-center justify-center mx-auto mb-2">
                  <i className="ri-shield-check-fill text-lg text-white"></i>
                </div>
                <p className="text-[#1B3A6B] font-semibold text-xs">Licensed &amp; Insured</p>
              </div>

              <div className="bg-[#1B3A6B]/5 rounded-lg p-4 text-center border border-[#1B3A6B]/10">
                <div className="w-10 h-10 bg-[#1B3A6B] rounded-full flex items-center justify-center mx-auto mb-2">
                  <i className="ri-star-fill text-lg text-white"></i>
                </div>
                <p className="text-[#1B3A6B] font-semibold text-xs">5 Star Rated</p>
              </div>

              <div className="bg-[#1B3A6B]/5 rounded-lg p-4 text-center border border-[#1B3A6B]/10">
                <div className="w-10 h-10 bg-[#B22234] rounded-full flex items-center justify-center mx-auto mb-2">
                  <i className="ri-time-fill text-lg text-white"></i>
                </div>
                <p className="text-[#1B3A6B] font-semibold text-xs">Same Day Service</p>
              </div>
            </div>
          </div>

          <div className="relative w-full h-[550px] rounded-2xl overflow-hidden shadow-2xl">
            <img
              src="https://static.readdy.ai/image/73df10f1d2f13e308059e9f42ef7d721/febc9f357455be866dd080ab7b920c0b.png"
              alt="Voltis - Florida Home Services"
              title="Voltis Florida Home Services"
              className="w-full h-full object-cover object-center"
            />
          </div>
        </div>
      </div>

      <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 animate-bounce">
        <a href="#services" className="text-gray-400 hover:text-[#B22234] transition-colors cursor-pointer">
          <i className="ri-arrow-down-line text-3xl"></i>
        </a>
      </div>
    </section>
  );
}
